export enum ChampionshipRegistrationChangeAction {
    AddMember = "AddMember",
    RemoveMember = "RemoveMember",
    CancelMember = "CancelMember",
    CancelBlankSlot = "CancelBlankSlot",
    ChangeCategory = "ChangeCategory"
}
